import './Ad_admissions_consultant.scss';
import * as S from '../../scss/theme';
import fnc from '../../mymod/commFunction';
import fncS4 from '../../mymod/commFunction4';
import HongButton from '../../comm/HongButton';
import CheckboxMui from '../../comm/CheckboxMui';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Admissions_consultant_content from '../../page_contract/Admissions_consultant_content';
import Admissions_consultant_price from '../../page_contract/Admissions_consultant_price';
import Ad_admissions_consultant_fileDown from './Ad_admissions_consultant_fileDown';


const Ad_admissions_consultant = ({parentCode}) => {
  const navigate = useNavigate();

  const [isModal, setIsModal] = useState(false);
  // const [list, setList] = useState([]);
  const [userInput, setUserInput] = useState({
    userName: '',
    email: '',
    hp: '',
    zipCode: '',
    address1: '',
    address2: '',

    zipCode_co: '',
    address1_co: '',
    address2_co: '',

    bank: '',
    banknumber: '',
    university_name: '',
    university_major: '',
    graduate_name: '',
    graduate_major: '',
    career: '',
    agreement_terms: '',
  });

  // const [parentCode, setParentCode] = useState(null);
  const [service_master, setService_master] = useState([]);
  const [regionMaster, setRegionMaster] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');

  const [files, setFiles] = useState({});
  const [fileNames, setFileNames] = useState({});




  // useEffect(() => {
  //   fncConsulting_service_master();
  //   fncConsulting_region_master();
  //   const userCode = fnc.fncSirialNum('p');//여기서 코드 발급
  //   setParentCode(userCode);
  // }, []);

  
  useEffect(() => {
    // const parentCode = 'p20250613213319755';
    fncSelect_list();
    fncSelect_list_service(parentCode);
    fncSelect_list_region(parentCode);
    fncSelect_list_fileUpload(parentCode) 
  }, []);


  function fncSelect_list() {
    fnc.sendAxios('/ad_admissions_consultantRoutes/select/consultant_agreement', { }, (res) => {
      if (res && Array.isArray(res)) {
        const newList = getRecords(res);
        setUserInput(newList[0]);
      } else {
        alert('검색에 실패했습니다.');
      }
    });

    function getRecords(res) {
      const records = res.map(item => ({
        sno: item["sno"],
        userCode: item["userCode"],
        userName: item["userName"],
        email: item["email"],
        hp: item["hp"],
        zipCode: item["zipCode"],
        address1: item["address1"],
        address2: item["address2"],
        zipCode_co: item["zipCode_co"],
        address1_co: item["address1_co"],
        address2_co: item["address2_co"],
        bank: item["bank"],
        banknumber: item["banknumber"],
        university_name: item["university_name"],
        university_major: item["university_major"],
        graduate_name: item["graduate_name"],
        graduate_major: item["graduate_major"],
        career: item["career"],
        agreement_terms: item["agreement_terms"],
        sDate: fnc.formatDate2(item["sDate"]),
        useyn: item["useyn"]
      }));
      return records;
    }

  }

  
  function fncSelect_list_service(parent_code) {//대상(특목)
    fnc.sendAxios('/ad_admissions_consultantRoutes/select/consultant_agreement_service', {parent_code }, (res) => {
      if (res && Array.isArray(res)) {
        const newList = getRecords(res);
        setService_master(newList);
      } else {
        alert('검색에 실패했습니다.');
      }
    });

    function getRecords(res) {
      const records = res.map(item => ({
        sno: item["sno"],
        parent_code: item["parent_code"],
        service_code: item["service_code"],
        service_name: item["service_name"],
        sort_order: item["sort_order"],
      }));
      return records;
    }

  }

  
  function fncSelect_list_region(parent_code) {//지역
    fnc.sendAxios('/ad_admissions_consultantRoutes/select/consultant_agreement_region', {parent_code}, (res) => {
      if (res && Array.isArray(res)) {
        const newList = getRecords(res);
        setRegionMaster( newList);
      } else {
        alert('검색에 실패했습니다.');
      }
    });

    function getRecords(res) {
      const records = res.map(item => ({
        sno: item["sno"],
        region_code: item["region_code"],
        region_group: item["region_group"],
        region_code: item["region_code"],
        region_name: item["region_name"],
        sort_order: item["sort_order"],
      }));
      return records;
    }

  };

  
  function fncSelect_list_fileUpload(parent_code) {//fileUpload
    fnc.sendAxios('/ad_admissions_consultantRoutes/select/consultant_agreement_fileUpload', {parent_code}, (res) => {
      if (res && Array.isArray(res)) {
        const newList = getRecords(res);
        // setRegionMaster( newList);
        console.log(res);
      } else {
        alert('검색에 실패했습니다.');
      }
    });

    function getRecords(res) {
      const records = res.map(item => ({
        sno: item["sno"],
        title: item["title"],
        parentCode: item["parentCode"],
        fileCode: item["fileCode"],
        fileName: item["fileName"],
      }));
      return records;
    }

  };



  
  // function fncConsulting_service_master() {//특목, 사관학교, 과기원..
  //   fnc.sendAxios('/igongAdmissions_consultantRoutes/select/set_consulting_service_master', { }, (res) => {
  //     if (res && res.length > 0) {
  //         setService_master(res);
  //     } else {
  //       console.log("속성이 obj 내에 없습니다.");
  //     }
  //   });
  // }


  const handleChange = (e) => {
    // const { name, value } = e.target;
    // setUserInput((prev) => ({ ...prev, [name]: value }));
  };


  //-----------------------------------------------------------------------------
   function fncConsulting_region_master() {//특목, 사관학교, 과기원..
    fnc.sendAxios('/igongAdmissions_consultantRoutes/select/set_consulting_region_master', { }, (res) => {
      if (res && res.length > 0) {
          console.log(res, 'region res');
          setRegionMaster(res); 
      } else {
        console.log("속성이 obj 내에 없습니다.");
      }
    });
  }

  // const handleCheckboxChangeRegion = (region_code) => {
  //   setSelectedRegions((prev) =>
  //     prev.includes(region_code)
  //       ? prev.filter(code => code !== region_code)
  //       : [...prev, region_code]
  //   );
  //   console.log(selectedRegions, 'selectedRegions');
  // };

  const groupRegionsByGroup = (regionMaster) => {
    const grouped = {};
    regionMaster.forEach(region => {
      if (!grouped[region.region_group]) {
        grouped[region.region_group] = [];
      }
      grouped[region.region_group].push(region);
    });
    return grouped;
  };




  //-----------------------------------------------------------------------------
 

// const handleUpload = async (file, filePrefix) => {

//   try {

//     const expireSec = 600; // presigned URL 유효시간 (초)
//     const fileCode = fnc.getSafeFileName(file.name, filePrefix);
//     const folder = 'upload/consultant';
//     const orgFileName = file.name;

//     fnc.sendAxios('/generate-upload-url', {fileName: fileCode, fileType: file.type,
//       folder: folder, sec: expireSec}, (presignedRes) => {
//       if (presignedRes) {
//           const { url, key } = presignedRes; 
//           fncS4.axiosPutFile(url, file); // 2. presigned URL로 S3에 직접 파일 PUT
//           fncInsertUploadRecord( parentCode, fileCode, orgFileName);
//         } else {
//           console.log('Error during file download');
//         }    
//       }); 
     
//   } catch (err) {
//     console.error('업로드 중 오류 발생:', err);
//     alert('오류가 발생했습니다.');
//   }
// };


function fncInsertUploadRecord( parentCode, fileCode, fileName) {
  const code = fnc.fncSirialNum('c');
  const extension = fileName.split('.').pop();
  const kind = extension;

  fnc.sendAxios(`/igongAdmissions_consultantRoutes/uploadRecord`, {
    parentCode, fileCode, fileName, code, kind }, (res) => {
    if (res) {
      // alert('완료되었습니다.');
    } else {
      console.log('uploadRecord 저장 중 오류');
    }
  });
}



  //===================================================================================
  return (
    // <S.Section2>
      <div className='Ad_admissions_consultant'>
        <div className='wrap-main'>
       
          <section className='section-consultant'>
            {/* <p className='title'>입시컨설턴트 등록</p> */}
            <div className='form-container'>

              <Admissions_consultant_content />
              <div className='agreement-box'>
                <CheckboxMui
                  checked={userInput.agreement_terms === '동의함'}
                    // onChange={e => setUserInput(prev => ({ ...prev, agreement_terms: e.target.checked }))}
                    label="위 계약에 동의합니다."
                    disableRipple={true}
                    readOnly
                  />
                  </div>
                  <label>*이름</label>
                  <input type='text' name='userName' value={userInput.userName} onChange={handleChange} readOnly />

                  <label>*이메일</label>
                  <input type='email' name='email' value={userInput.email} onChange={handleChange} readOnly />

                  <label>*휴대전화</label>
                  <input type='text' name='hp' value={userInput.hp} onChange={handleChange} placeholder='숫자만 입력' readOnly />

                  <label>*주소</label>
                  <div className='address-box'>
                  <input type='text' name='address1' value={userInput.address1} readOnly />
                  <input className='second' type='text' name='address2' value={userInput.address2} onChange={handleChange} placeholder='상세주소' readOnly />
                  </div>

                  <label>*근무지 주소</label>
                  <div className='address-box'>
                  <input type='text' name='address1_co' value={userInput.address1_co} readOnly />
                  <input className='second' type='text' name='address2_co' value={userInput.address2_co} onChange={handleChange} placeholder='상세주소' readOnly />
                  </div>

                  <label>*계좌 정보</label>
                  <input type='text' name='bank' value={userInput.bank} onChange={handleChange} placeholder='은행명' readOnly />
                  <input className='second' type='text' name='banknumber' value={userInput.banknumber} onChange={handleChange} placeholder='숫자만, 9~20자리' readOnly />

                  {/* 교과목 checkbox */}
              <article className='art-1'>
                <label>*입시컨설팅 전문영역</label>
                <div className='box-chkbox-1'>       
                  {service_master.map((item) => (
                      <CheckboxMui
                        value={item.service_code}
                        checked={true}
                        // onChange={() => handleCheckboxChange_service_master(item.service_code)}
                        label={item.service_name}
                        disableRipple={true}
                      />
                    ))}
                </div>
              </article>



              <label>*대학교 / 전공</label>
              <input type='text' name='university_name' value={userInput.university_name} onChange={handleChange}  placeholder='대학교명 입력'/>
              <input className='second' type='text' name='university_major' value={userInput.university_major} onChange={handleChange} placeholder='전공 입력' />

              <label>*대학원 / 전공</label>
              <input type='text' name='graduate_name' value={userInput.graduate_name} onChange={handleChange}  placeholder='대학원명 입력'/>
              <input className='second' type='text' name='graduate_major' value={userInput.graduate_major} onChange={handleChange}  placeholder='전공 입력'/>

              <label>*이력 | 경력사항</label>
              <textarea name='career' value={userInput.career} onChange={handleChange} placeholder='입시중심 상세기술 요망' />

             

              <article className='art-1'>
                <label>*입시컨설팅 가능지역</label>
                {Object.entries(groupRegionsByGroup(regionMaster)).map(([groupName, regions]) => (
                  <div key={groupName} className='box-chkbox-2'>
                    <p className='group-label'>{groupName}</p>
                    {regions.map((region) => (
                      <CheckboxMui
                        key={region.region_code}
                        value={region.region_code}
                        checked={true}
                        // onChange={() => handleCheckboxChangeRegion(region.region_code)}
                        label={region.region_name}
                        disableRipple={true}
                      />
                    ))}
                  </div>
                ))}
              </article>
          
          <Admissions_consultant_price />

        {/* 파일첨부 */}
       <section className="sec-photo-upload">
   
          <Ad_admissions_consultant_fileDown parentCode={parentCode} />
        
       </section>



        </div>
        </section>
        </div>

      
      </div>

     

    // </S.Section2>
  );
};

export default Ad_admissions_consultant;
